var productresponse = "";
var $site_url = "https://shopifyapp.randigift.com/";
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
                                  
function getProduct($attribute) {
  	$("body").addClass('has--overlay');
    $(".loadingOverlay").show();
    $.ajax({
        method: "POST",
        dataType: "json",
        data: {
            action: "getrandomproduct",
            'attribute': $attribute
        },
        url: $site_url + "ajax.php",
        success: function (data) {
            $("body").removeClass('has--overlay');
            $(".loadingOverlay").hide();
            if (!data.is_error) {
                productresponse = data;
                var producttodisplay = data.product[0];
                setCookie('timelimit__todisplay__gift',productresponse.timelimit,2);
                var originalprice = parseFloat(producttodisplay.originalprice);
                var getproductsid = getCookie('giftcardsid');
                $("#product__container").attr('data-productid', producttodisplay.productidinshopify);
                $(".product__img", $("#product__container")).attr(
                    "src",
                    producttodisplay.productImage
                );
                $(".checkoutlink", $("#product__container")).attr('data-checkoutlink', producttodisplay.checkoutlink)
                $(".product__title", $("#product__container"))
                    .html("")
                    .html(producttodisplay.producttitle);
                $(".originalprice", $("#product__container"))
                    .html("")
                    .html(theme.Currency.formatMoney(originalprice.toFixed(2)));
                $(".product__handle",$("#product__container")).attr('href',"https://randigift.com/products/"+producttodisplay.producthandle);
                if (getproductsid.length && JSON.parse(getproductsid).length >= 3 || !producttodisplay.discountprice) {
                    $(".originalprice", $("#product__container")).removeClass(
                        "line-throught-text"
                    );
                    $(".discountprice", $("#product__container")).html("");
                    $(".discount__text>span", $("#product__container")).html("");
                    $(".discount__text", $("#product__container")).hide();
                } else {
                    var dicountprice = producttodisplay.discountprice;
                    $(".discount__text", $("#product__container")).show();
                    $(".originalprice", $("#product__container")).addClass(
                        "line-throught-text"
                    );
                    $(".discountprice", $("#product__container"))
                        .html("")
                        .html(theme.Currency.formatMoney(dicountprice.toFixed(2)));
                    if(producttodisplay.discounttype == 0){
                      $(".discount__text>span", $("#product__container"))
                        .html("")
                        .html(producttodisplay.discountvalue);
                    }else{
                        $(".discount__text>span", $("#product__container"))
                        .html("")
                        .html(theme.Currency.formatMoney(producttodisplay.discountvalue));
                    }
                }
            } else {
              	Swal.fire({
                  type: 'error',
                  title: 'Oops...',
                  text: data.message,
				});
            }
        },
        error: function (error) {
            Swal.fire({
               type: 'error',
               title: 'Oops...',
               text: "Something went wrong",
			});
          	$("body").removeClass('has--overlay');
            $(".loadingOverlay").hide();
        }
    });
}

function setProductHTML(data, number) {
    var producttodisplay = data.product[number];
   
    var originalprice = parseFloat(producttodisplay.originalprice);
    var getproductsid = getCookie('giftcardsid');
	
    $("#product__container").attr('data-productid', producttodisplay.productidinshopify);
    $(".product__img", $("#product__container")).attr(
        "src",
        producttodisplay.productImage
    );
    $(".checkoutlink", $("#product__container")).attr('data-checkoutlink', producttodisplay.checkoutlink)
    $(".product__title", $("#product__container"))
        .html("")
        .html(producttodisplay.producttitle);
    $(".originalprice", $("#product__container"))
        .html("")
        .html(theme.Currency.formatMoney(originalprice.toFixed(2)));
    $(".product__handle",$("#product__container")).attr('href',"https://randigift.com/products/"+producttodisplay.producthandle);
    if (getproductsid.length && JSON.parse(getproductsid).length >= 3 || !producttodisplay.discountprice) {
        $(".originalprice", $("#product__container")).removeClass(
            "line-throught-text"
        );
        $(".discountprice", $("#product__container")).html("");
        $(".discount__text>span", $("#product__container")).html("");
        $(".discount__text", $("#product__container")).hide();
    } else {
        var dicountprice = producttodisplay.discountprice;
        $(".discount__text", $("#product__container")).show();
        $(".originalprice", $("#product__container")).addClass(
            "line-throught-text"
        );
        $(".discountprice", $("#product__container"))
            .html("")
            .html(theme.Currency.formatMoney(dicountprice.toFixed(2)));
        if(producttodisplay.discounttype == 0){
          $(".discount__text>span", $("#product__container"))
            .html("")
            .html(producttodisplay.discountvalue);
        }else{
        	$(".discount__text>span", $("#product__container"))
            .html("")
            .html(theme.Currency.formatMoney(producttodisplay.discountvalue));
        }
        
    }
} 




$(document).ready(function(){
//   if (window.customerId!=undefined && $('body').hasClass('template-index')) {
 if ($('body').hasClass('template-index')) {
    var checkifgiftcardisopened = getCookie('firstgiftcard');
    if (checkifgiftcardisopened !== ""){
      var timelimitinminute = getCookie('timelimit__todisplay__gift');
      var timeinsecond = Math.floor((Date.now() - checkifgiftcardisopened) / 1000);
      if (timelimitinminute !== "") {
        var getproductsid = getCookie('giftcardsid');
        if(parseInt(timelimitinminute * 60) > timeinsecond && getproductsid !=="" && JSON.parse(getproductsid).length >= 3){
        	 getProduct(1);
        }else{
        	 getProduct(0);
        }
      } else {
          getProduct(0);
      }
    }else{
     getProduct(0);
    }
 }
  var merrywrap = $("#merrywrap"),
        box = $(".giftbox"),
        step = 1,
        stepTimes = [1000, 1000, 1000, 1000];
    if($(".dashboard-wrapper").length){
      var windowHeight = $(window).height();
      var HederHeight = $(".site-header").outerHeight();
      $(".dashboard-wrapper").css("min-height",parseInt(windowHeight - HederHeight - 65)+"px");
    }
	$(window).resize(function(){
      if($(".dashboard-wrapper").length){
        var windowHeight = $(window).height();
        var HederHeight = $(".site-header").outerHeight();
        $(".dashboard-wrapper").css("min-height",parseInt(windowHeight - HederHeight - 65)+"px");
      }
	});
  	
    function incStep(step) {
        merrywrap.removeClass("step-" + Number(step - 1));
       merrywrap.addClass("step-" + step);
    }
  	
  	function runAnimation() {
        if (step === 1) {
            var checkifgiftcardisopened = getCookie('firstgiftcard');
            var getproductsid = getCookie('giftcardsid');
            var productid = $("#product__container").attr('data-productid');
            if (checkifgiftcardisopened !== "") {
                getproductsid = getCookie('giftcardsid');
                  if (getproductsid !== "" && JSON.parse(getproductsid).length >= 3) {	
                    	
                  } else {
                      var arrayofids = JSON.parse(getproductsid);
                      arrayofids.push(productid);
                      setCookie("giftcardsid", JSON.stringify(arrayofids), 1);
                  }
                
            } else {
                var firstgiftcardopentime = Date.now();
                setCookie("firstgiftcard", firstgiftcardopentime, 1);
                if (getproductsid == "") {
                    var productids = [];
                    productids.push(productid);
                    var arrayString = JSON.stringify(productids);
                    setCookie("giftcardsid", arrayString, 1);
                }
            }

        }
        incStep(step);
        if (step === 4) {
            
            return;
        }
        if (step === 3) {
            // set different delays for each item
            // setGridDelays();
            // showProductmodal();
            $(".slider").removeClass("hideslider");
        }
          setTimeout(function () {
              runAnimation();
          }, stepTimes[step - 1]);
          ++step;
    }
  box.on("click", runAnimation);
//   		if (window.customerId!=undefined){
//           box.on("click", runAnimation);
          
//     	} else {
//         	box.on("click", function () {
//             Swal.fire({
//                 title: "Login or register to play",
//                 type: "warning",
//                 showCancelButton: true,
//                 confirmButtonColor: "#3085d6",
//                 cancelButtonColor: "#d33",
//                 confirmButtonText: "Login"
//             }).then(result => {
//                 if (result.value) {
//                     window.location.href = "/account/login";
//                 }
//             });
//         	});
//     	}
          
  		
        
    $(".animation__replay").on("click", function () {
        var checkifgiftcardisopened = getCookie('firstgiftcard');
      	$(merrywrap).removeClass("step-4");
        $(".slider").addClass("hideslider");
        if(checkifgiftcardisopened !== ""){
          var timeinsecond = Math.floor((Date.now() - checkifgiftcardisopened) / 1000);
          var timeinminute = parseInt(Math.floor(timeinsecond / 60));
          if (timeinminute >= parseInt(productresponse.timelimit)) {
              setCookie("firstgiftcard", Date.now(), 1);
              var productids = [];
              setCookie("giftcardsid", JSON.stringify(productids), 1);
              Cookies.remove('allchacesover');
              getProduct(0);
          }else{
            var getproductsid = getCookie('giftcardsid');
            if (JSON.parse(getproductsid).length == 1) {
            	if(productresponse.totalcount == 1){
            		setProductHTML(productresponse, 0)
            	}else{
            		setProductHTML(productresponse, 1)
            	}
            }
            if (JSON.parse(getproductsid).length == 2) {
                if(productresponse.totalcount == 1){
            		setProductHTML(productresponse, 0)
            	}else{
            		setProductHTML(productresponse, 2)
            	}
            }
            if (getproductsid.length && JSON.parse(getproductsid).length >= 3) {
                  var showAlertMessage = getCookie('allchacesover');
                  if(showAlertMessage == ""){
                      setCookie("allchacesover", '1', 1);
                    Swal.fire({
                       type: 'success',
                       text: "Your three chances are over. Come back in "+productresponse.timelimit+" minutes for more discounts.",
                    });
                  }	
                var $attribute = '1';
            	getProduct($attribute);
            }
            
          }
        }else{
          var $attribute = '0';
          getProduct($attribute);
        }
        step = 1;
});
$(".checkoutlink").on("click", function (event) {
        event.preventDefault();
        var checkoutlink = $(this).attr('data-checkoutlink');
        $.ajax({
            method: "POST",
            dataType: "json",
            data: {
                action: "checkoutproduct",
                checkoutlink: checkoutlink
            },
            url: $site_url + "ajax.php",
            success: function (data) {
                if (data.is_error) {
                    Swal.fire({
                        type: "error",
                        title: "Oops...",
                        text: data.message
                    });
                } else {
                  if(getCookie("allchacesover")) {
                    $.get("/cart/clear",function(e){
                    	$.get(data.message, function (e) {
                            window.location.href = "https://birthdaygiftgenerator.com/checkout/";
                        });  
                    });
                  } else {
                    $.get(data.message, function (e) {
                        window.location.href = "https://birthdaygiftgenerator.com/checkout/";
                    });
                  }
                }
            },
            error: function (error) {
                Swal.fire({
                    type: "error",
                    title: "Oops...",
                    text: "Something went wrong"
                 });
            }
        });
    })
	
});